import React, { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import { FeedbackRow } from './FeedbackRow';
import { getOpinionValue } from '../../services/RentService';
import FeedbackDialog from './FeedbackDialog';
import StringService from '../../services/StringService';
import Loader from '../Layout/Loader';

const columnData = [
  {
    id: 'user_feedback_date',
    label: 'Date de la notation',
  },
  {
    id: 'start_site_name',
    label: 'Site',
  },
  {
    id: 'user',
    label: 'Client',
  },
  {
    id: 'user_email',
    label: 'Email',
  },
  {
    id: 'start_date',
    label: 'Début de location',
  },
  {
    id: 'duration',
    label: 'Durée de location',
  },
  {
    id: 'bike_number',
    label: 'N° du vélo',
  },
  {
    id: 'user_feedback',
    label: 'Avis client',
  },
];

const jsonDataToTableData = (feedbacks, users) => {
  return feedbacks.map(f => {
      const userId = f.user_id;
      const user = users && Object.keys(users).includes(userId) ? users[userId] : null;
      return {
        id: f.id,
        user_feedback_date: f.user_feedback_date,
        start_site_name: f.start_site.name,
        user_lastname: user ? user.lastname : '',
        user_firstname: user ? user.firstname : '',
        user_email: user ? user.email : '',
        start_date: f.start_date,
        duration: f.end_date - f.start_date,
        bike_number: f.bike.number,
        user_feedback_opinion: f.user_feedback_opinion,
        user_feedback: f.user_feedback,
      };
    },
  );
};

export const FeedbackTable = (props) => {

  const { feedbacks, users, pending } = props;
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('start_date');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [modalFeedback, setModalFeedback] = useState('');
  const [modalFeedbackOpinion, setModalFeedbackOpinion] = useState('');

  const handleClose = () => {
    setModalFeedback('');
    setModalFeedbackOpinion('');
    setOpen(false);
  };

  const showFeedback = (message, opinion) => {
    setModalFeedback(message);
    setModalFeedbackOpinion(opinion);
    setOpen(true);
  };

  const sortElement = (a, b, property, order) => {
    let prop1, prop2;
    if (property === 'user_feedback') {
      prop1 = getOpinionValue(a);
      prop2 = getOpinionValue(b);
    } else if (property === 'user') {
      prop1 = StringService.formatClientName(a.user_lastname, a.user_firstname);
      prop2 = StringService.formatClientName(b.user_lastname, b.user_firstname);
    } else {
      prop1 = (a[property] !== null && a[property] !== undefined) ? a[property] : -1;
      prop2 = (b[property] !== null && b[property] !== undefined) ? b[property] : -1;
    }
    if (order === 'asc') {
      return prop1 > prop2 ? -1 : 1;
    }
    return prop1 < prop2 ? -1 : 1;
  };

  const createSortHandler = property => {
    let newOrder = 'desc';
    if (orderBy === property && newOrder === order) {
      newOrder = 'asc';
    }
    setOrder(newOrder);
    setOrderBy(property);
  };

  useEffect(() => {
    let newData = jsonDataToTableData(feedbacks, users);
    newData.sort((a, b) => sortElement(a, b, orderBy, order));
    setData(newData);
  }, [order, orderBy]);

  const handleChangePage = (event, page) => {
    event.stopPropagation();
    setPage(page);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
  };

  if (feedbacks.length > 0 && data.length === 0) {
    const tableData = jsonDataToTableData(feedbacks, users);
    if (tableData && tableData.length > 0) {
      let data = [...tableData];
      data.sort((a, b) => sortElement(a, b, orderBy, order));
      setData(data);
    } else {
      setData([0]);
    }
  }

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            {columnData.map(column => (
              <TableCell
                key={column.id}
                padding={'normal'}
                sortDirection={orderBy === column.id
                  ? order
                  : false}>
                <Tooltip
                  title="Trier"
                  placement={column.numeric
                    ? 'bottom-end'
                    : 'bottom-start'}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={() => createSortHandler(column.id)}>
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            ), this)}
          </TableRow>
        </TableHead>
        <TableBody>
          {pending &&
          <tr>
            <td colSpan={8}>
              <Loader />
            </td>
          </tr>
          }
          {!pending && data.length > 0
          && data.slice(page * rowsPerPage,
            (
              page * rowsPerPage
            ) + rowsPerPage,
          ).map(fb => (
            <FeedbackRow
              key={fb.id}
              feedback={fb}
              showFeedback={showFeedback}
            />
          ))}
          {!pending && data.length <= 0 &&
          <tr>
            <td colSpan={8}>
              <Typography variant="subtitle1">Aucun avis</Typography>
            </td>
          </tr>
          }
        </TableBody>
      </Table>
      <KobooTablePagination
        numberOfItems={feedbacks.length}
        rowsPerPage={rowsPerPage}
        label="Avis par page"
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <FeedbackDialog
        open={open}
        handleClose={handleClose}
        modalFeedback={modalFeedback}
        modalFeedbackOpinion={modalFeedbackOpinion}
      />
    </div>
  );
};
export default FeedbackTable;



// WEBPACK FOOTER //
// ./src/components/Feedback/FeedbackTable.jsx